import React from 'react';
import { volumes } from '../data/content';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Volumes() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-258" data-mp="1lwl5eoi9puq1">
      <div className="mx-auto max-w-3xl" data-id="element-259" data-mp="184ey7rx3ey2q">
        <Eyebrow data-id="element-260" data-mp="185q5i1pqynyl">What's included</Eyebrow>
        <SectionTitle data-id="element-261" data-mp="1c57a6sxcnh2p">
          5 complete volumes. <Mark data-id="element-262" data-mp="1c609j8tzb4at">One organized professional system.</Mark>
        </SectionTitle>

        <ul className="mt-8 space-y-4" data-id="element-263" data-mp="1zw4d5g76341t">
          {volumes.map(volume => <li key={volume.number} className="overflow-hidden rounded-2xl border border-blue-950/10 shadow-sm" data-id="element-264" data-mp="24uo11m5bmpwt">
              <div className="flex items-center gap-3 bg-blue-700 px-4 py-3 md:px-5" data-id="element-265" data-mp="1qv658mtlycdy">
                <span className="shrink-0 rounded-md bg-white px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-blue-950 md:text-[11px]" data-id="element-266" data-mp="1vsy7oarvpgwe">
                  Volume {volume.number}
                </span>
                <h3 className="text-sm font-black uppercase leading-tight text-white md:text-base" data-id="element-267" data-mp="kfc8rxw7w0xo">{volume.name}</h3>
              </div>
              <div className="bg-white px-4 py-4 md:px-5" data-id="element-268" data-mp="3oa9aurpxjdb7">
                <p className="text-sm font-semibold leading-relaxed text-blue-950" data-id="element-269" data-mp="3ja559wqk82zr">{volume.intro}</p>
                {volume.items && <>
                    <p className="mt-3 text-xs font-bold uppercase tracking-wide text-slate-600" data-id="element-270" data-mp="3t79gx2ms4g2b">{volume.itemsLabel}</p>
                    <ul className="mt-2 grid gap-x-4 gap-y-1 sm:grid-cols-2" data-id="element-271" data-mp="b14uwwt48nc9">
                      {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-272" data-mp="61s7oayc1e95">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-700" aria-hidden="true" data-id="element-273" data-mp="kq504xy7oeyw" />
                          {item}
                        </li>)}
                    </ul>
                  </>}
                {volume.details.map(paragraph => <p key={paragraph} className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-274" data-mp="psdspt769f0h">
                    {paragraph}
                  </p>)}
                <p className="mt-3 text-[11px] font-black uppercase tracking-wider text-blue-700" data-id="element-275" data-mp="11tvmix49ydt6">{volume.tagline}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}